import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=07b6e58f&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=07b6e58f&prod&lang=css"
import style1 from "./goods.vue?vue&type=style&index=1&id=07b6e58f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6e58f",
  null
  
)

export default component.exports